import PaarPassportContainer from './PaarPassportContainer';
export default PaarPassportContainer;
